var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeaderNew'),_vm._m(0),_c('AppFooterNew')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-image"},[_c('img',{attrs:{"src":require("../../assets/error/404error.png"),"alt":""}})])
}]

export { render, staticRenderFns }